import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import apiProvider from '../apiProvider/api';
import apiProvider from '../apiProvider/api';
import { IMAGE_URL } from '../../src/network/apiClient'
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
const ItemsPerPage = 10; // Number of items per page


const LocationPageLayer = () => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [formErrors, setFormErrors] = useState({});


    const [formData, setFormData] = useState({
        location: "",
        locationStatus: "Active",

    });
    const [locationData, setLocationData] = useState([]);


    const fetchData = async () => {
        try {
            const result = await apiProvider.getLocations();
            console.log(result, "result");
            if (result) {
                setLocationData(result.response.data.data);
            }
        } catch (error) {
            console.error("Error fetching category data:", error);
        }
    };


    useEffect(() => {
        fetchData();
    }, []); // Empty dependency array means this runs once on mount

    // Function to determine category type name
    const getCategoryTypeName = (type) => {
        return type === '1' ? 'Online' : 'Offline'; // Adjust as needed based on your actual types
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = {};

        if (!formData.location) errors.location = "location name is required.";
        if (!formData.locationStatus) errors.locationStatus = "locationStatus is required.";

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        console.log("Form submitted:", formData);

        const input = new FormData();
        input.append("locationStatus", formData.locationStatus);
        input.append("location", formData.location);


        console.log(...input, "input");

        try {
            let response;
            if (isEditMode) {
                // For edit mode, include the ID and use update endpoint
                input.append("id", formData.id);
                response = await apiProvider.updateLocation(input);
            } else {
                // For create mode
                response = await apiProvider.addLocation(input);
            }

            console.log(response, "response");

            if (response) {
                // const notify = () => toast("Wow so easy!");
                // Reset form
                toast(response.response.data.message)
                setFormData({
                    location: "",
                    locationStatus: "Active", // Changed to lowercase to match your select values

                });

                setFormErrors({});
                // Refresh data
                fetchData();
                // Reset edit mode
                setIsEditMode(false);

                const backdrop = document.querySelector(".modal-backdrop");
                const modal = document.getElementById("exampleModalEdit");

                if (modal) {
                    modal.classList.remove("show");
                    modal.classList.remove("d-block");
                    modal.setAttribute("aria-hidden", "true");
                    modal.style.display = "none";
                }

                if (backdrop) {
                    backdrop.remove();
                }

                document.body.classList.remove("modal-open");
                document.body.style.overflow = "auto"; // 
            }

        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
    };

    const handleEditClick = (category) => {
        setIsEditMode(true);
        setFormData({
            id: category.id,
            location: category.location,
            locationStatus: category.locationStatus,
        });
        ;
    };



    const handleDelete = async (category) => {
        console.log(category, "ccccccccc");

        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete "${category.location}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                title: 'swal-title-small',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // 👇 Call your delete API or logic here
                const result = await apiProvider.deleteLocation(category.id);
                console.log(result, "rrrrrrrrrrrr");
                if (result) {
                    deleteCategory(category.id);
                }



            }
        });
    };

    // Example delete function (you should replace this with your actual API call)
    const deleteCategory = async (id) => {
        try {
            // await your API delete call
            console.log("Deleting category with ID:", id);

            Swal.fire(
                'Deleted!',
                'Category has been deleted.',
                'success'
            );
            // Refresh data
            fetchData();

            // Optionally refresh the list or update UI
        } catch (error) {
            Swal.fire(
                'Error!',
                'There was a problem deleting the category.',
                'error'
            );
        }
    };


    // Calculate total pages
    const totalPages = Math.ceil(locationData.length / ItemsPerPage);

    // Get the current page's data
    const startIndex = (currentPage - 1) * ItemsPerPage;
    const endIndex = startIndex + ItemsPerPage;
    const currentData = locationData.slice(startIndex, endIndex);

    // Handle page change
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-end">
                <div></div>
                <div>
                    <button
                        type="button"
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-right gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalEdit"
                        onClick={() => {
                            setFormData({
                                location: "",
                                locationStatus: "Active",

                            });
                            const input = document.getElementById("categoryImage");
                            if (input) input.value = "";
                        }}
                    >
                        {/* <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        /> */}
                        Add Location
                    </button>
                </div>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Location</th>
                                <th scope="col">Location Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((category, index) => (
                                <tr key={category.id}>
                                    <td>
                                        <div className="d-flex align-items-center gap-10">

                                            {index + 1}
                                        </div>
                                    </td>

                                    <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.location}
                                        </span>
                                    </td>
                                    <td className="d-flex align-items-center">
                                        <span className={`${category.locationStatus === 'Active'
                                            ? 'bg-success-focus text-success-600 border border-success-main'
                                            : 'bg-danger-focus text-danger-600 border border-danger-main'} 
                px-24 py-4 radius-4 fw-medium text-sm`}>
                                            {category.locationStatus.charAt(0).toUpperCase() + category.locationStatus.slice(1)}
                                        </span>
                                    </td>

                                    <td className="text-right">
                                        <div className="d-flex align-items-center gap-10 justify-content-center">
                                            {/* <button
                                                type="button"
                                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                            >
                                                <Icon
                                                    icon="majesticons:eye-line"
                                                    className="icon text-xl"
                                                />
                                            </button> */}
                                            <button
                                                type="button"
                                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModalEdit"
                                                onClick={() => handleEditClick(category)}
                                            >
                                                <Icon icon="lucide:edit" className="menu-icon" />
                                            </button>
                                            <button
                                                type="button"
                                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                onClick={() => handleDelete(category)}
                                            >
                                                <Icon
                                                    icon="fluent:delete-24-regular"
                                                    className="menu-icon"
                                                />

                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                        <span>
                            Showing {startIndex + 1} to {Math.min(endIndex, locationData.length)} of {locationData.length} entries
                        </span>
                        <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                            {/* Previous Page Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <Icon icon="ep:d-arrow-left" />
                                </Link>
                            </li>

                            {/* Page Numbers */}
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className="page-item">
                                    <Link
                                        className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === i + 1 ? "bg-primary-600 text-white" : "bg-neutral-200 text-secondary-light"
                                            }`}
                                        to="#"
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                        {i + 1}
                                    </Link>
                                </li>
                            ))}

                            {/* Next Page Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <Icon icon="ep:d-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                )}
            </div>

            {/* add course type model */}
            <div
                className="modal fade"
                id="exampleModalEdit"
                // tabIndex={-1}
                aria-labelledby="exampleModalEditLabel"
                aria-hidden="true"
                tabindex="-1" role="dialog"
            >
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                {/* <h1 className="modal-title fs-5"> */}
                                {isEditMode ? 'Edit Location' : 'Add New Location'}
                                {/* </h1> */}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Location Name</label>
                                        <input
                                            type="text"
                                            name="location"
                                            className="form-control"
                                            value={formData.location}
                                            onChange={handleChange}
                                        />
                                        {formErrors.location && (
                                            <div className="text-danger small mt-1">{formErrors.location}</div>
                                        )}

                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">location Status</label>
                                        <select
                                            className="form-select"
                                            name="locationStatus"
                                            value={formData.locationStatus}
                                            onChange={handleChange}
                                        >
                                            <option value="Active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary text-sm">
                                            {isEditMode ? 'Update' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            {/* add category model */}
            <ToastContainer />

        </div>


    )
}

export default LocationPageLayer;